<app-navbar />
<div class="main-container">

  <form class="form" [formGroup]="fichaForm" (ngSubmit)="onSubmit()">

    <h2>Ficha de Recadastramento</h2>

    <fieldset>

      <legend>DADOS DO CONSUMIDOR</legend>

      <div>

        <div class="grid-2">
          <div>
            <label>Nome do Consumidor</label>
            <input type="text" formControlName="nomeConsumidor" />
          </div>
          <div>
            <label>CPF</label>
            <input type="text" formControlName="cpf" mask="000.000.000-00" placeholder="000.000.000-00" />
          </div>

        </div>

        <div class="grid-4">
          <div>
            <label>Telefone</label>
            <input type="text" formControlName="telefone" mask="(00) 00000-0000" placeholder="(00) 00000-0000" />
          </div>
          <div>
            <label>Ciclo de leitura</label>
            <input type="text" formControlName="cicloDeLeitura" />
          </div>
          <div>
            <label>Número Imóvel</label>
            <input type="number" formControlName="numeroImovel" />
          </div>
          <div>
            <label>Referência</label>
            <input type="text" formControlName="referencia" placeholder="Referência de localização" />
          </div>
        </div>

        <div class="grid-3">
          <div>
            <label>Data Cadastro</label>
            <input type="date" formControlName="dataCadastroOriginal" readonly class="campo-readonly" />
          </div>
          <div>
            <label>Loja/Loc</label>
            <input formControlName="lojLoc" type="text" placeholder="Ex: 001" />
          </div>
          <div>
            <label>Concessão Expediente</label>
            <input formControlName="concessaoExpediente" type="text" />
          </div>
        </div>

        <div class="grid-3">
          <div>
            <label>Sistema de Abastecimento</label>
            <input type="text" formControlName="sistemaAbastecimento" />
          </div>
          <div>
            <label>Tipo de Abastecimento</label>
            <input type="text" formControlName="tipoAbastecimento" />
          </div>
          <div>
            <label>Tipos de Utilização</label>
            <select formControlName="tipoUtilizacao">
              <option value="utilizacao" selected>Selecione a Utilização</option>
              <option value="comercio">Comércio</option>
              <option value="DOMICILIAR">Domiciliar</option>
              <option value="industria">Indústria</option>
              <option value="publica">Pública</option>
            </select>
          </div>
        </div>

      </div>
    </fieldset>

    <fieldset>
      <div>
        <label>Possui Débito</label>
        <select formControlName="possuiDebito">
          <option [ngValue]="false">Não</option>
          <option [ngValue]="true">Sim</option>
        </select>
      </div>

      <!-- Container condicional para Valor e Data Débito -->
      <ng-container *ngIf="fichaForm.get('possuiDebito')?.value === true">
        <div class="grid-2">
          <div>
            <label>Valor do Débito</label>
            <input formControlName="valorDebito" type="text" placeholder="R$ 0,00" (input)="formatarValorDebito()" />
          </div>
          <div>
            <label>Data do Débito</label>
            <input formControlName="dataInicioDebito" type="date" />
          </div>
        </div>
      </ng-container>
    </fieldset>

    <fieldset formGroupName="endereco">
      <legend>Endereço</legend>
      <div class="grid-3">
        <div>
          <label>CEP</label>
          <input type="text" formControlName="cep" (input)="onCepChange($event)" mask="00000-000"
            placeholder="00000-000" />
        </div>

        <div>
          <label>Logradouro</label>
          <input type="text" formControlName="logradouro" />
        </div>

        <div>
          <label>Complemento</label>
          <input type="text" formControlName="complemento" />
        </div>

        <div>
          <label>Bairro</label>
          <input type="text" formControlName="bairro" />
        </div>

        <div>
          <label>Localidade</label>
          <input type="text" formControlName="localidade" />
        </div>

        <div>
          <label>UF</label>
          <input type="text" formControlName="uf" />
        </div>

        <div>
          <label>Número</label>
          <input type="text" formControlName="numero" />
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend>ÁGUA</legend>
      <div class="grid-3">
        <div><label>Nº Hidrômetro</label><input formControlName="numeroHidrometro" type="number"
            placeholder="Número do hidrômetro" /></div>
        <div>
          <label>Marcação</label>
          <input formControlName="marcacao" type="text" placeholder="Ex: 12345" />
        </div>
        <div>
          <label>Selo Reloj.</label>
          <input formControlName="seloReloj" type="text" placeholder="Número do selo" />
        </div>
        <div>
          <label>Selo Virola</label>
          <input formControlName="seloVirola" type="text" placeholder="Número do selo" />
        </div>
        <div>
          <label>Ramal</label>
          <select formControlName="ramal">
            <option value="ramal" selected>Selecione o ramal</option>
            <option value="1/2">1/2</option>
            <option value="3/4">3/4</option>
            <option value="acima">Acima</option>
          </select>
        </div>

        <div>
          <label>Direto</label>
          <select formControlName="direto">
            <option [ngValue]="true" selected>Sim</option>
            <option [ngValue]="false">Não</option>
          </select>
          <!-- Container condicional para o Filtro -->
          <ng-container *ngIf="fichaForm.get('direto')?.value === false">
            <label>Filtro</label>
            <input formControlName="filtro" type="text" placeholder="Ex: Sim/Não" />
          </ng-container>
        </div>
      </div>

      <hr />

      <h4>Cisterna</h4>
      <div class="grid-2">
        <div>
          <label>Há cisterna?</label>
          <select formControlName="hacisterna">
            <option [ngValue]="false">Não</option>
            <option [ngValue]="true">Sim</option>
          </select>
        </div>

        <!-- Container para campos condicionais -->
        <ng-container *ngIf="fichaForm.get('hacisterna')?.value === true">
          <div>
            <label>Capacidade Informada</label>
            <input formControlName="capacidadeCisternaInformada" type="text" placeholder="Ex: 1000L" />
          </div>
          <div>
            <label>Observações</label>
            <textarea formControlName="observacoesCisterna" placeholder="Observações"></textarea>
          </div>
        </ng-container>
      </div>

      <hr />

      <h4>Reservatórios Elevados</h4>
      <div class="grid-2">
        <div>
          <label>Há Reservatórios Elevados?</label>
          <select formControlName="hareservatorio">
            <option [ngValue]="false">Não</option>
            <option [ngValue]="true">Sim</option>
          </select>
        </div>

        <!-- Container para campos condicionais -->
        <ng-container *ngIf="fichaForm.get('hareservatorio')?.value === true">
          <div>
            <label>Capacidade Informada</label>
            <input formControlName="capacidadeReservatorioElevado" type="text" placeholder="Ex: 500L" />
          </div>
          <div>
            <label>Observações</label>
            <input formControlName="observacoesReservatorioElevado" type="text" placeholder="Observações" />
          </div>
        </ng-container>
      </div>

      <hr />

      <fieldset>
        <legend>Economias</legend>
        <div class="grid-2">
          <div>
            <label>Tipos de Economias</label>
            <select formControlName="tipoEconomia">
              <option value="economia" selected>Selecione a Economia</option>
              <option value="comercio">Comércio</option>
              <option value="DOMICILIAR">Domiciliar</option>
              <option value="industria">Indústria</option>
            </select>
          </div>
          <div>
            <label>Número de Economias</label>
            <input type="number" formControlName="numeroDeEconomias" placeholder="Ex: 1" />
          </div>
          <!-- Campo Sub Categoria -->
          <div>
            <label>Sub Categoria</label>
            <select formControlName="dUnica">
              <option value="dunica" selected>Selecione a D. ÚNICA</option>
              <option value="publica">Pública</option>
              <option value="federal">Federal</option>
              <option value="estatal">Estatal</option>
            </select>
          </div>
        </div>

        <!-- Domiciliar -->
        <div class="grid-3" *ngIf="fichaForm.get('tipoEconomia')?.value === 'DOMICILIAR'">
          <label>Nº Quartos
            <input formControlName="numeroDeQuartos" type="number" placeholder="Ex: 2" />
          </label>
          <label>Nº Salas
            <input formControlName="numeroDeSalas" type="number" placeholder="Ex: 1" />
          </label>
          <label>Nº WC/PAV
            <input formControlName="numeroWcPav" type="number" placeholder="Ex: 1" />
          </label>
        </div>

        <!-- Comércio -->
        <div class="grid-3" *ngIf="fichaForm.get('tipoEconomia')?.value === 'comercio'">
          <div>
            <label>Alunos</label>
            <input formControlName="numeroDeAlunos" type="number" placeholder="Quantidade de alunos" />
          </div>
          <div>
            <label>Banheiros</label>
            <input formControlName="banheiros" type="number" placeholder="Quantidade de banheiros" />
          </div>
          <div>
            <label>Nº Boxes</label>
            <input formControlName="numeroDeBoxes" type="number" placeholder="Quantidade de boxes" />
          </div>
          <label>Tipo Comércio
            <input formControlName="tipoComercio" type="text" placeholder="Ex: Loja/Mercado/Restaurante" />
          </label>
          <label>Área (m²)
            <input formControlName="areaMetroQuadrado" type="number" placeholder="Ex: 100" />
          </label>
        </div>

        <!-- Indústria -->
        <div class="grid-3" *ngIf="fichaForm.get('tipoEconomia')?.value === 'industria'">
          <div>
            <label>Banheiros</label>
            <input formControlName="banheiros" type="number" placeholder="Quantidade de banheiros" />
          </div>
          <label>Tipo Indústria
            <input formControlName="tipoIndustria" type="text" placeholder="Ex: Têxtil/Metalúrgica" />
          </label>
          <label>Área (m²)
            <input formControlName="areaMetroQuadrado" type="number" placeholder="Ex: 100" />
          </label>
        </div>

        <div class="grid-2">
          <div>
            <label>Outras Formas Abastecimento:</label>
            <select formControlName="outrosAbastecimentos">
              <option value="outrosAbastecimento" selected>Selecione uma opção</option>
              <option value="POCO">POÇO</option>
              <option value="MINA">MINA</option>
              <option value="NASCENTE">NASCENTE</option>
            </select>
          </div>
        </div>

      </fieldset>

      <h4>Piscina</h4>
      <div class="grid-2">
        <div>
          <label>Existe Piscina?</label>
          <select formControlName="existePiscina">
            <option [ngValue]="false" selected>Não</option>
            <option [ngValue]="true">Sim</option>
          </select>
        </div>
        <!-- Only show dimensions field when existePiscina is true -->
        <div *ngIf="fichaForm.get('existePiscina')?.value === true">
          <label>Dimensões:</label>
          <input formControlName="dimensoesPiscina" type="text" placeholder="Ex: 10m x 5m x 1,5m" />
        </div>
      </div>
    </fieldset>

    <!-- Seção ESGOTO -->
    <fieldset>
      <legend>ESGOTO</legend>
      <div>
        <label>Tem coletor?</label>
        <select formControlName="haColetor">
          <option [ngValue]="false" selected>Não</option>
          <option [ngValue]="true">Sim</option>
        </select>
      </div>

      <!-- Container condicional para detalhes do esgoto -->
      <ng-container *ngIf="fichaForm.get('haColetor')?.value === true">
        <label>Efluente encaminhado para:</label>
        <div class="grid-4">
          <div>
            <label>Coletor</label>
            <select formControlName="coletor">
              <option [ngValue]="false" selected>Não</option>
              <option [ngValue]="true">Sim</option>
            </select>
          </div>
          <div>
            <label>GAP</label>
            <select formControlName="gap">
              <option [ngValue]="false" selected>Não</option>
              <option [ngValue]="true">Sim</option>
            </select>
          </div>
          <div>
            <label>RIO</label>
            <select formControlName="rio">
              <option [ngValue]="false" selected>Não</option>
              <option [ngValue]="true">Sim</option>
            </select>
          </div>
          <div>
            <label>VALÃO</label>
            <select formControlName="valao">
              <option [ngValue]="false" selected>Não</option>
              <option [ngValue]="true">Sim</option>
            </select>
          </div>
          <div>
            <label>Foça/Filtro</label>
            <select formControlName="focaFiltro">
              <option [ngValue]="false" selected>Não</option>
              <option [ngValue]="true">Sim</option>
            </select>
          </div>
          <div>
            <label>Vala</label>
            <select formControlName="vala">
              <option [ngValue]="false" selected>Não</option>
              <option [ngValue]="true">Sim</option>
            </select>
          </div>
          <div>
            <label>Sumidouro</label>
            <select formControlName="sumid">
              <option [ngValue]="false" selected>Não</option>
              <option [ngValue]="true">Sim</option>
            </select>
          </div>
        </div>
        <label>A vala ou valão é de:</label>
        <select formControlName="tipoValaValao">
          <option value="" selected>Selecione o tipo</option>
          <option value="terra">Terra</option>
          <option value="concretado">Concretado(a)</option>
          <option value="manilhado">Manilhado(a)</option>
        </select>
      </ng-container>
    </fieldset>

    <!-- Seção de fotos (somente visualização) -->
    <fieldset>
      <legend>FOTOS DO LOCAL</legend>
      <div class="fotos-container">
        <div class="fotos-grid" *ngIf="fotosLocal.length > 0">
          <div class="foto-item" *ngFor="let foto of fotosLocal">
            <div class="foto-wrapper">
              <img [src]="foto.url" alt="Foto do Local" class="foto-local" (click)="abrirModalFoto(foto.url)" />
            </div>
          </div>
        </div>
        <div *ngIf="fotosLocal.length === 0" class="alert alert-warning">
          Nenhuma foto disponível.
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend>OUTRAS INFORMAÇÕES</legend>
      <label>Descrição da Conclusão</label>
      <textarea formControlName="outrasInformacoes" rows="6"
        placeholder="Descreva a conclusão da vistoria..."></textarea>

      <!-- Fotos de documentos (somente visualização) -->
      <fieldset>
        <legend>FOTOS DE DOCUMENTOS</legend>
        <div class="fotos-container">
          <div class="fotos-grid" *ngIf="fotosDocumentos.length > 0">
            <div class="foto-item" *ngFor="let foto of fotosDocumentos">
              <div class="foto-wrapper">
                <img [src]="foto.url" alt="Foto do Documento" class="foto-local" (click)="abrirModalFoto(foto.url)" />
              </div>
            </div>
          </div>
          <div *ngIf="fotosDocumentos.length === 0" class="alert alert-warning">
            Nenhuma foto disponível.
          </div>
        </div>
      </fieldset>

      <fieldset>
        <div class="grid-2">
          <div>
            <label>Extraído MEMº</label>
            <input formControlName="extraidoMemo" type="text" placeholder="Número do memorando" />
          </div>
          <div>
            <label>Em</label>
            <input formControlName="dataExtraidoMemo" type="date" />
          </div>
        </div>
      </fieldset>

      <!-- Dados do vistoriador (somente visualização) -->
      <fieldset>
        <legend>Dados do Vistoriador</legend>
        <div class="grid-1 vistoriador-foto">
          <img *ngIf="fotoVistoriadorUrl" [src]="fotoVistoriadorUrl" alt="Foto do Vistoriador"
            class="foto-vistoriador" />
          <div *ngIf="!fotoVistoriadorUrl" class="alert alert-warning">
            Foto não disponível
          </div>
        </div>
        <div class="vistoriador-info grid-3">
          <div>
            <label>Nome do Vistoriador</label>
            <input type="text" formControlName="nomeVistoriante" readonly />
          </div>
          <div>
            <label>CPF</label>
            <input type="text" formControlName="cpfVistoriador" readonly mask="000.000.000-00" />
          </div>
          <div>
            <label>Empresa</label>
            <input type="text" formControlName="empresaVistoriador" readonly />
          </div>
        </div>
      </fieldset>

      <!-- Assinatura do vistoriador (somente visualização) -->
      <fieldset>
        <legend>Assinatura do Vistoriador</legend>
        <div class="signature-container">
          <img *ngIf="assinaturaVistoriador" [src]="assinaturaVistoriador" alt="Assinatura do Vistoriador"
            class="signature-image" />
          <div *ngIf="!assinaturaVistoriador" class="alert alert-warning">
            Assinatura não disponível
          </div>
        </div>
      </fieldset>

      <!-- Dados do acompanhante (editáveis) -->
      <div class="grid-3">
        <div>
          <label>Nome do Acompanhante</label>
          <input type="text" formControlName="nomeAcompanhante" placeholder="João da Silva" />
        </div>
        <div>
          <label>CPF do Acompanhante</label>
          <input type="text" formControlName="cpfAcompanhante" mask="000.000.000-00" placeholder="000.000.000-00" />
        </div>
        <div>
          <label>Telefone do Acompanhante</label>
          <input type="text" formControlName="telefoneAcompanhante" mask="(00) 00000-0000"
            placeholder="(00) 00000-0000" />
        </div>
      </div>

      <!-- Assinatura do acompanhante (somente visualização) -->
      <fieldset>
        <legend>Assinatura do Acompanhante</legend>
        <div class="signature-container">
          <img *ngIf="assinaturaAcompanhante" [src]="assinaturaAcompanhante" alt="Assinatura do Acompanhante"
            class="signature-image" />
          <div *ngIf="!assinaturaAcompanhante" class="alert alert-warning">
            Assinatura não disponível
          </div>
        </div>
      </fieldset>

      <!-- Botão Editar/Salvar/Excluir -->
      <div class="button-group" style="text-align: right; margin-top: 20px;">
        <button *ngIf="!modoEdicao" type="button" class="btn btn-primary" (click)="iniciarEdicao()">
          <i class="fas fa-edit"></i> Editar
        </button>
        <button *ngIf="!modoEdicao" type="button" class="btn btn-danger" (click)="handleDeleteConsumer()"
          [disabled]="!isSuperAdmin"
          [title]="isSuperAdmin ? 'Excluir consumidor' : 'Somente SuperAdministrador pode excluir consumidores'">
          <i class="fas fa-trash-alt"></i> Excluir
        </button>
        <button *ngIf="modoEdicao" type="submit" class="btn btn-success">
          <i class="fas fa-save"></i> Salvar
        </button>
        <!-- Botão Voltar -->
          <button type="button" class="btn btn-secondary" (click)="voltarPagina()">
            <i class="fas fa-arrow-left"></i> Voltar
          </button>
        
      </div>
    </fieldset>
  </form>

  <!-- Modal de Visualização de Foto -->
  <div class="modal-foto" [class.show]="mostrarModalFoto" *ngIf="mostrarModalFoto" (click)="fecharModalFoto()">
    <div class="modal-foto-content" (click)="$event.stopPropagation()">
      <button type="button" class="btn-close-foto" (click)="fecharModalFoto()">
        <i class="fas fa-times"></i>
      </button>
      <img [src]="fotoSelecionada" alt="Foto Ampliada" class="foto-ampliada">
    </div>
  </div>
</div>